export default {
  GET_ALL: `#graphql
  query getOrders($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getOrders(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        order,
        isSale,
        isCommunity,
        status,
        quantitySale,
        dni,
        name,
        phones,
        email,
        address,
        location,
        department,
        remitData {
          name,
          location,
          phone,
          department,
          address,
          generatedBy,
          createdAt
        },
        remitDataGenerated,
        dataLocked,
        hasNoveltyData,
        noveltyData {
          change,
          from,
          to,
          createdBy,
          createdAt
        },
        hasProductChange,
        productChange {
          product,
          from,
          to,
          returnTier,
          createdBy,
          createdAt,
          item {
            product,
            sizes,
            quantityCart,
            picked,
            checked,
            images,
            folder,
            subfolder,
            brand
          }
        },
        methodPay,
        methodPayCost,
        conveyor,
        weliveryEnabled,
        conveyorCost,
        codeName,
        codeType,
        codePercent,
        codeValue,
        deliveryTime,
        community,
        mpCode,
        isWholesaler,
        isDropshipping,
        isGift,
        userPayConveyor,
        cod,
        tip,
        adviser,
        tracking {
          id,
          deviceSessionId,
          ip,
          ipReal,
          country,
          location,
          device,
          operatingSystem,
          referrer,
          userAgent,
          fbp,
          fbc,
          ttp,
          ttclid,
          payFacebook,
          payTiktok,
          beginSession,
          endSession,
          isWholesaler,
          openedCart,
          openedForm,
          openedFilters,
          pressPayButton,
          productsDisplayed,
          totalProducts,
          addedCart {
            product,
            article,
            person,
            size,
            colors,
            priceSale,
            priceSaleCommunity,
            priceUnit,
            priceThree,
            priceThreeCommunity,
            priceWholesaler
          },
          addedFilter {
            type,
            value
          },
          trackAds {
            key,
            value
          },
          trackSocial {
            key,
            value
          },
          trackStore {
            key,
            value
          }
        }
        cart {
          product,
          sizes,
          quantityCart,
          refundedQuantity,
          quantityBonus,
          quantityTransfer,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          picked,
          checked,
          tiers,
          design,
          brand,
          cost,
          isClearence,
          appliedPrice,
          appliedPriceName,
          productQuantity,
          productSubtotal
        },
        deliveries {
          delivery,
          nameRecipient,
          phonesRecipient,
          addressRecipient,
          conveyor,
          idRemission,
          idWelivery,
          weliveryReference,
          dateWelivery,
          cost,
          trackingCancelled,
          locationRecipient,
          departmentRecipient,
          tracking,
          createdBy,
          createdAt,
          deliveredBy,
          deliveredAt,
          inProgressAt,
          inProgressBy,
          declinedAt,
          declinedBy,
          deliveredAt,
          deliveredBy,
          status,
          type
        },
        refunds {
          refund,
          order,
          status,
          value,
          method,
          type,
          account,
          accountType,
          observations {
            observation,
            createdAt,
            createdBy
          },
          createdAt,
          createdBy,
          declinedBy,
          declinedAt,
          approvedAt,
          approvedBy
          refundedBy,
          refundedAt
        },
        invoices {
          order,
          status,
          value,
          tascode
        },
        changes {
          createdAt,
          change,
          status
        },
        createdAt,
        declinedAt,
        declinedBy,
        approvedAt,
        approvedBy,
        paidAt,
        paidBy,
        packedAt,
        packedBy,
        sentAt,
        sentBy,
        recoveredAt,
        recoveredBy,
        deliveredAt,
        deliveredBy,
        collectedAt,
        collectedBy,
        collectedValue,
        brand,
        paidWholesaler,
        payU {
          platform,
          platformUser,
          platformUserName,
          orderId,
          state,
          error,
          methodPay,
          value,
          success,
          cardType,
          bin,
          lastFour,
          cash {
            EXPIRATION_DATE,
            REFERENCE,
            URL_PAYMENT_RECEIPT_PDF,
            URL_PAYMENT_RECEIPT_HTML,
          },
          pse {
            BANK_URL
          },
          daviplataPhone,
          nequiPhone,
          redirectUrl,
          responseCode,
          tokenExpirationDate,
          createdAt 
        },
        payManual {
          state,
          methodPay,
          value,
          createdAt,
          createdBy,
          receipt
        },
        bonuses {
          bonus,
          originalValue,
          usedValue,
          remainingValue,
          status,
          createdAt,
          type,
          transactions {
            order,
            valueUsed,
            usedAt
          }
        },
        bonusesApplied {
          bonus,
          originalValue,
          usedValue,
          remainingValue,
          status,
          createdAt,
          transactions {
            order,
            valueUsed,
            usedAt
          }
        },
        bonusesTotal,
        pendingAt,
        statusHistory {
          status
          createdBy
          createdAt
        },
        observations {
          observation,
          type,
          createdAt,
          createdBy
        },
        saleByUnit,
        total,
        subtotal,
        priceDiscount,
        codeDiscount,
        totalDiscount,
        percentPriceDiscount,
        percentCodeDiscount,
        percentTotalDiscount,
        quantity,
        lat,
        lng,
        notifications {
          history {
            platform,
            status,
            error,
            createdAt
          }
        },
        fraudReview {
          status,
          fraudDismissedCount,
          fraudConfirmedCount,
          lastReviewedAt,
          lastReviewedBy,
          activeCase
        }
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getOrdersHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getOrdersHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        email,
        collectedAt,
        collectedBy,
        collectedValue,
        isDropshipping
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateOrder($order: String!, $orderUpdate: OrderUpdateInput!) {
    updateOrder(order:$order, orderUpdate: $orderUpdate)
    {
      order
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteOrder($order: String!) {
    deleteOrder(order:$order)         
  }`,

  GET_BY_ORDER: `#graphql
  query getByOrder($order: String!, $id: String, $fourDigits: String) {
    getByOrder(order: $order, id: $id, fourDigits: $fourDigits) {
      name,
      location,
      phones,
      email,
      department,
      address,
      deliveryTime,
      community,
      methodPay,
      methodPayCost,
      conveyor,
      conveyorCost,
      tip,
      codeName,
      codeType,
      codeValue,
      codePercent,
      isWholesaler,
      status,
      quantitySale,
      cart{
        product,
        sizes,
        quantityCart,
        refundedQuantity,
        quantityBonus,
        quantityTransfer,
        images,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        folder,
        subfolder,
        article,
        person,
        colors,
        appliedPrice,
        appliedPriceName,
        productQuantity,
        productSubtotal
      },
      createdAt,
      saleByUnit,
      total,
      subtotal,
      priceDiscount,
      codeDiscount,
      totalDiscount,
      percentPriceDiscount,
      percentCodeDiscount,
      percentTotalDiscount,
      quantity
    }   
  }`,

  GET_BY_ORDER_ADMIN: `#graphql
  query getByOrderAdmin($order: String!) {
    getByOrderAdmin(order: $order) {
      status,
      quantitySale,
      name,
      order,
      brand,
      createdAt,
      dni,
      email,
      phones,
      address,
      location,
      department,
      remitData {
        name,
        location,
        phone,
        department,
        address,
        generatedBy,
        createdAt
      },
      remitDataGenerated,
      dataLocked,
      hasNoveltyData,
      noveltyData {
        change,
        from,
        to,
        createdBy,
        createdAt
      },
      hasProductChange,
      productChange {
        product,
        from,
        to,
        returnTier,
        createdBy,
        createdAt,
        item {
          product,
          sizes,
          quantityCart,
          picked,
          checked,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          design,
          brand,
          appliedPrice,
          appliedPriceName,
          productQuantity,
          productSubtotal
        }
      },
      productChangeHistory {
        action,
        product,
        from,
        to,
        returnTier,
        reason,
        createdBy,
        createdAt
      },
      methodPay,
      methodPayCost,
      tip,
      conveyorCost,
      codeName,
      codeType,
      codeValue,
      codePercent,
      community,
      cart {
        product,
        sizes,
        quantityCart,
        refundedQuantity,
        quantityBonus,
        quantityTransfer,
        images,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        folder,
        subfolder,
        article,
        person,
        colors,
        picked,
        checked,
        tiers,
        design,
        brand,
        isClearence,
        appliedPrice,
        appliedPriceName,
        productQuantity,
        productSubtotal
      },
      isSale,
      saleByUnit,
      isCommunity,
      isDropshipping,
      isWholesaler,
      conveyor,
      weliveryEnabled,
      cod,
      isGift,
      userPayConveyor,
      observations {
        observation,
        type
      },
      deliveries {
        delivery,
        dniDeliveryMan,
        nameRecipient,
        phonesRecipient,
        addressRecipient,
        locationRecipient,
        departmentRecipient,
        tracking,
        conveyor,
        idRemission,
        idWelivery,
        weliveryReference,
        dateWelivery,
        weliveryPackageCount,
        weliveryStatus,
        weliveryReceiptUrl,
        weliverySettledMonth,
        weliverySettledAt,
        cost,
        estimatedCost,
        status,
        trackingCancelled,
        createdAt
      },
      total,
      subtotal,
      priceDiscount,
      codeDiscount,
      totalDiscount,
      percentPriceDiscount,
      percentCodeDiscount,
      percentTotalDiscount,
      quantity,
      fraudReview {
        status,
        fraudDismissedCount,
        fraudConfirmedCount,
        lastReviewedAt,
        lastReviewedBy,
        activeCase
      }
    }   
  }`,

  ADD_PRODUCT: `#graphql
  mutation addProductOrder($order: String!, $product: String!, $size: String!, $quantity: Int!, $tier: String) {
    addProductOrder(order: $order, product: $product, size: $size, quantity: $quantity, tier: $tier)        
  }`,

  SUBTRACT_PRODUCT: `#graphql
  mutation subtractProductOrder($order: String!, $product: String!, $size: String!, $quantity: Int!, $tier: String) {
    subtractProductOrder(order: $order, product: $product, size: $size, quantity: $quantity, tier: $tier)        
  }`,

  DECLINE: `#graphql
  mutation declineOrder($order: String!) {
    declineOrder(order: $order)
  }`,

  APPROVE: `#graphql
  mutation approveOrder($order: String!) {
    approveOrder(order: $order)
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveOrder($order: String!) {
    disapproveOrder(order: $order)        
  }`,

  PAY: `#graphql
  mutation payOrder($order: String!) {
    payOrder(order: $order)        
  }`,

  DELETE_PAY: `#graphql
  mutation deletePayOrder($order: String!) {
    deletePayOrder(order: $order)        
  }`,

  ADD_PAY_MANUAL: `#graphql
  mutation addPayManualOrder($order: String!, $value: Int!, $methodPay: String!) {
    addPayManualOrder(order: $order, value: $value, methodPay: $methodPay)        
  }`,

  REMOVE_BONUS_FROM_ORDER: `#graphql
  mutation removeBonusFromOrder($order: String!, $bonus: String!) {
    removeBonusFromOrder(order: $order, bonus: $bonus)
  }`,

  ADD_BONUS_TO_ORDER: `#graphql
  mutation addBonusToOrder($order: String!, $bonus: String!) {
    addBonusToOrder(order: $order, bonus: $bonus)
  }`,

  GET_AVAILABLE_BONUSES_FOR_ORDER: `#graphql
  query getAvailableBonusesForOrder($order: String!) {
    getAvailableBonusesForOrder(order: $order) {
      bonus
      phone
      brand
      type
      status
      originalValue
      remainingValue
      usedValue
    }
  }`,

  DECLINE_PAY_MANUAL: `#graphql
  mutation declinePayManualOrder($order: String!, $payIndex: Int!) {
    declinePayManualOrder(order: $order, payIndex: $payIndex)     
  }`,

  APPROVE_PAY_MANUAL: `#graphql
  mutation approvePayManualOrder($order: String!, $payIndex: Int!) {
    approvePayManualOrder(order: $order, payIndex: $payIndex)     
  }`,

  CHECK_STATE_PAY_U: `#graphql
  mutation checkStatePayUOrder($order: String!, $payIndex: Int!, $platform: String) {
    checkStatePayUOrder(order: $order, payIndex: $payIndex, platform: $platform)     
  }`,

  PICK_PRODUCT_ORDER: `#graphql
  mutation pickProductOrder($order: String!, $product: String!, $size: String!, $tier: String!) {
    pickProductOrder(order: $order, product: $product, size: $size, tier: $tier)     
  }`,

  UNPICK_PRODUCT_ORDER: `#graphql
  mutation unpickProductOrder($order: String!, $product: String!, $size: String!, $tier: String!, $returnTier: String) {
    unpickProductOrder(order: $order, product: $product, size: $size, tier: $tier, returnTier: $returnTier)     
  }`,

  CHECK_PRODUCT_ORDER: `#graphql
  mutation checkProductOrder($order: String!, $product: String!, $size: String!) {
    checkProductOrder(order: $order, product: $product, size: $size)     
  }`,

  PACK: `#graphql
  mutation packOrder($order: String!) {
    packOrder(order: $order)
  }`,

  UNPACK: `#graphql
  mutation unpackOrder($order: String!) {
    unpackOrder(order: $order)        
  }`,

  GENERATE_REMIT_DATA: `#graphql
  mutation generateRemitData($order: String, $change: String) {
    generateRemitData(order: $order, change: $change) {
      order
      change
      success
      message
      remitDataGenerated
      dataLocked
      name
      location
      department
      address
      phones
      remitData {
        name
        location
        phone
        department
        address
        generatedBy
        createdAt
      }
    }
  }`,

  UNLOCK_ORDER_DATA: `#graphql
  mutation unlockOrderData($order: String!) {
    unlockOrderData(order: $order) {
      order
      dataLocked
    }
  }`,

  LOCK_ORDER_DATA: `#graphql
  mutation lockOrderData($order: String!) {
    lockOrderData(order: $order) {
      order
      dataLocked
    }
  }`,

  GET_DATA_NOVELTY_COUNT: `#graphql
  query getOrderDataNoveltyCount {
    getOrderDataNoveltyCount
  }`,

  GET_PRODUCT_CHANGE_COUNT: `#graphql
  query getOrderProductChangeCount {
    getOrderProductChangeCount
  }`,

  GET_DATA_NOVELTIES: `#graphql
  query getOrderDataNovelties {
    getOrderDataNovelties {
      order
      status
      name
      location
      department
      address
      phones
      brand
      createdAt
      hasNoveltyData
      remitDataGenerated
      dataLocked
      total
      userPayConveyor
      remitData {
        name
        location
        phone
        department
        address
        generatedBy
        createdAt
      }
      noveltyData {
        change
        from
        to
        createdBy
        createdAt
      }
      deliveries {
        delivery
        nameRecipient
        phonesRecipient
        addressRecipient
        locationRecipient
        departmentRecipient
        tracking
        conveyor
        idRemission
        idWelivery
        weliveryReference
        cost
        estimatedCost
        status
        trackingCancelled
        createdAt
      }
    }
  }`,

  CLOSE_DATA_NOVELTY: `#graphql
  mutation closeOrderDataNovelty($order: String!) {
    closeOrderDataNovelty(order: $order) {
      order
      hasNoveltyData
    }
  }`,

  GET_PRODUCT_CHANGES: `#graphql
  query getOrderProductChanges {
    getOrderProductChanges {
      order
      status
      name
      location
      department
      brand
      createdAt
      hasProductChange
      productChange {
        product
        from
        to
        returnTier
        createdBy
        createdAt
        item {
          product
          brand
          person
          article
          design
          colors
          folder
          subfolder
          images
          sizes
          quantityCart
          picked
          checked
        }
      }
      productChangeHistory {
        action
        product
        from
        to
        returnTier
        reason
        createdBy
        createdAt
      }
    }
  }`,

  GET_PRODUCT_CHANGE_DETAIL: `#graphql
  query getProductChangeDetail($order: String!) {
    getByOrderAdmin(order: $order) {
      order
      status
      name
      location
      department
      brand
      createdAt
      hasProductChange
      productChange {
        product
        from
        to
        returnTier
        createdBy
        createdAt
        item {
          product
          brand
          person
          article
          design
          colors
          folder
          subfolder
          images
          sizes
          quantityCart
          picked
          checked
        }
      }
      productChangeHistory {
        action
        product
        from
        to
        returnTier
        reason
        createdBy
        createdAt
      }
    }
  }`,

  GET_AVAILABLE_SIZES_FOR_CHANGE: `#graphql
  query getAvailableSizesForChange($order: String!, $product: String!, $size: String!) {
    getAvailableSizesForChange(order: $order, product: $product, size: $size) {
      size
      quantityAvailable
    }
  }`,

  REQUEST_SIZE_CHANGE: `#graphql
  mutation requestOrderSizeChange($order: String!, $product: String!, $from: String!, $to: String!, $returnTier: String) {
    requestOrderSizeChange(order: $order, product: $product, from: $from, to: $to, returnTier: $returnTier) {
      order
      hasProductChange
      cart {
        product
        sizes
        quantityCart
        picked
        checked
      }
      productChange {
        product
        from
        to
        returnTier
        createdBy
        createdAt
        item {
          product
          sizes
          quantityCart
          picked
          checked
          images
          folder
          subfolder
          brand
        }
      }
      productChangeHistory {
        action
        product
        from
        to
        returnTier
        reason
        createdBy
        createdAt
      }
    }
  }`,

  PICK_PRODUCT_CHANGE_ORDER: `#graphql
  mutation pickProductChangeOrder($order: String!, $product: String!, $size: String!, $tier: String!) {
    pickProductChangeOrder(order: $order, product: $product, size: $size, tier: $tier)
  }`,

  UNPICK_PRODUCT_CHANGE_ORDER: `#graphql
  mutation unpickProductChangeOrder($order: String!, $product: String!, $size: String!, $tier: String!, $returnTier: String) {
    unpickProductChangeOrder(order: $order, product: $product, size: $size, tier: $tier, returnTier: $returnTier)
  }`,

  CHECK_PRODUCT_CHANGE_ORDER: `#graphql
  mutation checkProductChangeOrder($order: String!, $product: String!, $size: String!) {
    checkProductChangeOrder(order: $order, product: $product, size: $size)
  }`,

  REJECT_PRODUCT_CHANGE: `#graphql
  mutation rejectOrderProductChange($order: String!, $reason: String!) {
    rejectOrderProductChange(order: $order, reason: $reason) {
      order
      hasProductChange
      productChangeHistory {
        action
        product
        from
        to
        returnTier
        reason
        createdBy
        createdAt
      }
    }
  }`,

  SEND: `#graphql
  mutation sendOrder($order: String!, $skipGuide: Boolean) {
    sendOrder(order: $order, skipGuide: $skipGuide)
  }`,

  SEND_STATUS_NOTIFICATION: `#graphql
  mutation sendOrderStatusNotification($order: String!) {
    sendOrderStatusNotification(order: $order)
  }`,

  BACK_SEND: `#graphql
  mutation backSendOrder($order: String!) {
    backSendOrder(order: $order)        
  }`,

  ADD_OBSERVATION: `#graphql
  mutation addObservation($order: String!, $observation: String!, $type: String!) {
    addObservation(order: $order, observation: $observation, type: $type)        
  }`,

  NEW_DELIVERY: `#graphql
  mutation newDeliveryOrder($order: String!, $type: String!) {
    newDeliveryOrder(order: $order, type: $type)        
  }`,

  COLLECT: `#graphql
  mutation collectOrder($order: String!) {
    collectOrder(order: $order)
  }`,

  RETURN_COLLECT: `#graphql
  mutation returnCollectOrder($order: String!) {
    returnCollectOrder(order: $order)        
  }`,

  RECOVER: `#graphql
  mutation recoverOrder($order: String!) {
    recoverOrder(order: $order)  
  }`,

  INTEGRATION: `#graphql
  mutation integrationOrder($order: OrderIntegrationInput!) {
    integrationOrder(order: $order)        
  }`,

  CHANGE_METHOD_PAY: `#graphql
  mutation changeMethodPayOrder($order: String!, $methodPay: String!) {
    changeMethodPayOrder(order:$order, methodPay: $methodPay)
    {
      order
    }            
  }`,

  CHANGE_USER_PAY_CONVEYOR: `#graphql
  mutation changeUserPayConveyorOrder($order: String!, $userPayConveyor: Boolean!) {
    changeUserPayConveyorOrder(order: $order, userPayConveyor: $userPayConveyor) {
      order
    }
  }`,

  CHANGE_WHOLESALER: `#graphql
  mutation changeWholesalerOrder($order: String!, $isWholesaler: Boolean!) {
    changeWholesalerOrder(order:$order, isWholesaler: $isWholesaler)
    {
      order
    }            
  }`,

  PAID_WHOLESALER: `#graphql
  mutation paidWholesalerOrder($order: String!, $paid: Boolean!) {
    paidWholesalerOrder(order:$order, paid: $paid)
    {
      order
    }
  }`,

  UPDATE_PRICE_PRODUCT: `#graphql
  mutation updatePriceProductOrder($order: String!, $product: String!, $price: Int!) {
    updatePriceProductOrder(order: $order, product: $product, price: $price)        
  }`,

  BAN_USER: `#graphql
  mutation banUser($order: String!) {
    banUser(order: $order)        
  }`,

  UPLOAD_IMAGE_RECEIPT: `#graphql
  mutation uploadImageReceipt($image: Upload!, $order: String!) {
    uploadImageReceipt(image: $image, order: $order)        
  }`,

  DELETE_IMAGE_RECEIPT: `#graphql
  mutation deleteImageReceipt($order: String!, $index: Int!) {
    deleteImageReceipt(order: $order, index: $index)        
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/order.js